module.exports = __webpack_public_path__ + "img/purchase_02.a25e9d49.png";